import { render, staticRenderFns } from "./experimentalreport.vue?vue&type=template&id=2a010fbf&scoped=true&"
import script from "./experimentalreport.vue?vue&type=script&lang=js&"
export * from "./experimentalreport.vue?vue&type=script&lang=js&"
import style0 from "./experimentalreport.vue?vue&type=style&index=0&id=2a010fbf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a010fbf",
  null
  
)

export default component.exports